<template>
  <vs-popup
    class="holamundo"
    title="Sipariş Detayı"
    :active="active"
    @update:active="$emit('update:active', $event)"
  >
    <div class="con-expand-users w-full receipt-bg" v-if="order">
      <div v-if="order.orderStatus === -1" class="cancel-info-box">
        <p><strong>İptal Sebebi:</strong> {{ order.cancelReason || '-' }}</p>
        <p><strong>İptal Eden:</strong> {{ order.canceledByUserName || '-' }}</p>
        <p><strong>İptal Tarihi:</strong> {{ order.canceledDate ? new Date(order.canceledDate).toLocaleString('tr-TR') : '-' }}</p>
      </div>
      <vs-row vs-type="flex" vs-w="12" class="receipt-container">
        <vs-col vs-type="block" vs-w="12" vs-lg="7" class="pr-md-6 border-right">
          <div class="receipt-left">
            <h6 class="bold text-muted mb-2 uppercase tracking-widest text-center border-bottom pb-2">SİPARİŞ DETAYI</h6>
            <div class="flex items-center text-xsmall weight-700 text-muted border-bottom pb-1 mb-2">
              <div class="flex-grow pr-2">ÜRÜN ADI</div>
              <div class="w-16 text-center">ADET</div>
              <div class="w-24 text-right">TUTAR</div>
            </div>
            <div v-for="entry in order.cartEntries" :key="entry.id" class="item-row mb-2">
              <div class="flex items-start text-small">
                <div class="flex-grow text-dark font-medium leading-tight pr-2">
                  {{ entry.productName }}
                  <div v-if="entry.extras && entry.extras.length > 0" class="mt-1 pl-2">
                    <div v-for="extra in entry.extras" :key="extra.id" class="text-xsmall text-secondary italic">
                      + {{ extra.name }} <span v-if="extra.quantity > 1" class="ml-1">(x{{ extra.quantity }})</span>
                    </div>
                  </div>
                </div>
                <div class="w-16 text-center text-primary font-bold">x{{ entry.quantity }}</div>
                <div class="w-24 text-right font-semibold">{{ $toCurrency(entry.price) }}</div>
              </div>
            </div>
            <div class="mt-4 pt-3 border-top-thick receipt-summary">
              <div class="flex justify-between items-center mb-1 text-small font-bold">
                <span class="text-muted">Ara Toplam:</span>
                <span>{{ $toCurrency(calculateItemsTotal(order.cartEntries)) }}</span>
              </div>
              <div
                v-for="disc in getDiscounts(order.paymentInformations)"
                :key="disc.id"
                class="flex justify-between items-center mb-1 text-small text-danger italic"
              >
                <span>{{ disc.paymentMethod.name }}<span v-if="disc.unit == '%'"> (%{{ disc.value }})</span>:</span>
                <span>-{{ $toCurrency(disc.price) }}</span>
              </div>
              <div class="flex justify-between items-center mt-2 pt-2 border-top-dashed">
                <span class="text-small bold uppercase text-dark">GENEL TOPLAM:</span>
                <span class="text-medium bold text-primary">
                  {{ $toCurrency(calculateItemsTotal(order.cartEntries) - calculateDiscountTotal(order.paymentInformations)) }}
                </span>
              </div>
            </div>
          </div>
        </vs-col>
        <vs-col vs-type="block" vs-w="12" vs-lg="5" class="pl-md-6 mt-sm-6">
          <div class="receipt-right">
            <h6 class="bold text-success mb-3 uppercase tracking-widest text-center border-bottom pb-2">TAHSİLATLAR</h6>
            <div v-if="getActualPayments(order.paymentInformations).length === 0" class="text-center py-4 text-muted italic">
              Henüz tahsilat kaydı yok.
            </div>
            <div
              v-for="payment in getActualPayments(order.paymentInformations)"
              :key="payment.id"
              class="payment-card mb-3 p-3 rounded bg-light bg-opacity-30 border"
            >
              <div class="flex justify-between items-center">
                <div class="flex flex-col">
                  <span class="text-small font-bold text-dark">{{ payment.paymentMethod.name }}</span>
                  <span v-if="payment.description" class="text-xsmall text-muted">{{ payment.description }}</span>
                </div>
                <div class="flex items-center">
                  <span class="text-medium font-bold text-success mr-3">{{ $toCurrency(payment.price) }}</span>
                </div>
              </div>
            </div>
            <div class="mt-6 text-center text-xsmall text-muted border-top pt-4">
              <div>İŞLEMİ YAPAN: {{ order.userName }}</div>
              <div>ŞUBE: {{ order.branchName }}</div>
              <div>TARİH: {{ order.date }} - {{ order.time }}</div>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: "OrderReceiptPopup",
  props: {
    order: {
      type: Object,
      default: () => ({}),
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isDiscountPayment(payment) {
      if (!payment || !payment.paymentMethod || !payment.paymentMethod.name) return false;
      const name = payment.paymentMethod.name.toLowerCase();
      const keywords = ["indirim", "i̇ndirim", "discount", "ındırım", "ikram", "i̇kram", "treat", "iskonto", "kampanya", "düşüm", "dusum"];
      return keywords.some((kw) => name.includes(kw));
    },
    getActualPayments(payments) {
      if (!payments) return [];
      return payments.filter((p) => !this.isDiscountPayment(p));
    },
    getDiscounts(payments) {
      if (!payments) return [];
      return payments.filter((p) => this.isDiscountPayment(p));
    },
    calculateItemsTotal(entries) {
      if (!entries) return 0;
      return entries.reduce((acc, curr) => acc + curr.price, 0);
    },
    calculateDiscountTotal(payments) {
      if (!payments) return 0;
      return this.getDiscounts(payments).reduce((acc, curr) => acc + curr.price, 0);
    },
  },
};
</script>

<style>
.receipt-bg {
  background: white url("https://www.transparenttextures.com/patterns/white-paper.png");
}
.receipt-container {
  max-width: 1000px;
  margin: 0 auto;
}
.cancel-info-box {
  max-width: 1000px;
  margin: 0 auto 1rem auto;
  text-align: left;
  background-color: #fdecea;
  border: 1px solid #f5c6cb;
  border-radius: 6px;
  padding: 10px 14px;
}
.cancel-info-box p {
  margin: 4px 0;
}
.border-top-thick {
  border-top: 2px solid #333;
}
.receipt-summary {
  background: #fdfdfd;
  padding: 10px;
  border: 1px dashed #ccc;
}
.text-large {
  font-size: 1.4rem;
}
.text-medium {
  font-size: 1.15rem;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.payment-card {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  transition: all 0.2s;
}
.payment-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}
@media (min-width: 992px) {
  .pr-md-6 {
    padding-right: 1.5rem !important;
  }
  .pl-md-6 {
    padding-left: 1.5rem !important;
  }
}
@media (max-width: 991px) {
  .receipt-left,
  .receipt-right {
    padding: 0 !important;
  }
  .border-right {
    border-right: none !important;
    border-bottom: 2px dashed #eee;
    margin-bottom: 2rem;
    padding-bottom: 2rem;
  }
}
</style>
